import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {User} from "../../model/user";
import {AdminService} from "../../services/admin.service";
import {MatTableModule} from "@angular/material/table";
import {AsyncPipe} from "@angular/common";

@Component({
  selector: 'app-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss'],
  standalone: true,
  imports: [
    MatTableModule,
    AsyncPipe,
  ]
})
export class AdminUsersComponent implements OnInit {

  licenceOwners$: Observable<User[]>;
  readonly columns = ['email', 'displayName', 'role'];

  constructor(private adminService: AdminService) {
  }

  ngOnInit(): void {
    this.licenceOwners$ = this.adminService.getAllOwners();
  }
}
